import { create } from "zustand";
import { IUserImages } from "@/types/user.types";
import selectColorTypeImages from "@/components/common/selectColorTypeImages";
import { UserForImages } from "@/types/stateTypes";

export const useUserImages = create<IUserImages>((set) => ({
  data: {
    design_colors_primary: selectColorTypeImages[0].color,
    design_colors_button: selectColorTypeImages[0].buttonColor,
    headline: "",
    description: "",
    button: "",
    button_url: "",
    website: "",
    image_grid_view: "0",
    initialFiles: [
      {
        originalName: "fashion1.jpg",
        id: 0,
        metadata: { caption: "Your Caption..." },
        path: "empty",
        image: `/builder/qr-types/1.jpg`,
      },
      {
        originalName: "fashion2.jpg",
        id: 0,
        metadata: { caption: "Your Caption..." },
        path: "empty",
        image: `/builder/qr-types/2.jpg`,
      },
      {
        originalName: "fashion3.jpg",
        id: 0,
        metadata: { caption: "Your Caption..." },
        path: "empty",
        image: `/builder/qr-types/3.jpg`,
      },
    ],
  },
  config: {},
  addButton: [
    {
      value: "Shop now",
      icon: "",
    },
    {
      value: "Learn more",
      icon: "",
    },
    {
      value: "Visit us online",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],
  showButton: false,
  setUserParams: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setConfig: (val) =>
    set((state) => ({
      ...state,
      config: { ...state.config, val },
    })),
  setShowButton: (val) => {
    set((state) => {
      return { ...state, showButton: val };
    });
  },
  destroyImages: () => {
    set(() => {
      return {
        data: {
          design_colors_primary: selectColorTypeImages[0].color,
          design_colors_button: selectColorTypeImages[0].buttonColor,
          headline: "",
          description: "",
          button: "",
          button_url: "",
          website: "",
          image_grid_view: "0",
          initialFiles: [
            {
              originalName: "fashion1.jpg",
              id: 0,
              metadata: { caption: "" },
              path: "empty",
              image: `/builder/qr-types/1.jpg`,
            },
            {
              originalName: "fashion2.jpg",
              id: 1,
              metadata: { caption: "" },
              path: "empty",
              image: `/builder/qr-types/2.jpg`,
            },
            {
              originalName: "fashion3.jpg",
              id: 2,
              metadata: { caption: "" },
              path: "empty",
              image: `/builder/qr-types/3.jpg`,
            },
          ],
        },
        addButton: [
          {
            value: "Shop now",
            icon: "",
          },
          {
            value: "Learn more",
            icon: "",
          },
          {
            value: "Visit us online",
            icon: "",
          },
          {
            value: "Custom",
            icon: "/common/edit-icon.svg",
          },
        ],
        showButton: false,
      };
    });
  },
}));

export const useUserForImages = create<UserForImages>((set) => ({
  logoImage: {
    name: "",
    image: "",
    type: "",
    static_image: "",
  },
  screenImage: {
    name: "",
    image: "",
    type: "",
  },
  barCodeImage: {
    name: "",
    image: "",
    type: "",
  },
  setLogoImage: (val) => {
    set((state) => {
      return { ...state, logoImage: { ...state.logoImage, ...val } };
    });
  },
  setScreenImage: (val) => {
    set((state) => {
      return { ...state, screenImage: { ...state.screenImage, ...val } };
    });
  },
  destroyUserImage: () => {
    set({
      logoImage: {
        name: "",
        image: "",
        type: "",
      },
      screenImage: {
        name: "",
        image: "",
        type: "",
      },
    });
  },
}));
